// Login Module
export const SET_STATUS_MESSAGE = 'SET_STATUS_MESSAGE'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_LOGIN_LOADING = 'SET_LOGIN_LOADING'
export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES'
export const SET_FEATURE_TOGGLE = 'SET_FEATURE_TOGGLE'

// Upload Module
export const SET_UPLOAD_MODAL_ERROR = 'SET_UPLOAD_MODAL_ERROR'
export const SET_UPLOAD_STATUS = 'SET_UPLOAD_STATUS'
export const SET_UPLOAD_STATUS_MESSAGE = 'SET_UPLOAD_STATUS_MESSAGE'
export const SET_UPLOAD_SHOW_OFF = 'SET_UPLOAD_SHOW_OFF'
export const SET_DUPLICATED_ORDERS = 'SET_DUPLICATED_ORDERS'
export const CLEAR_DUPLICATED_ORDERS = 'CLEAR_DUPLICATED_ORDERS'
export const SET_UPLOAD_FILES = 'SET_UPLOAD_FILES'
export const SET_FILES_SENT_STATUS = 'SET_FILES_SENT_STATUS'
export const SET_UPLOAD_MAINTENANCE_STATUS = 'SET_UPLOAD_MAINTENANCE_STATUS'
export const SET_UPLOAD_MAINTENANCE_MESSAGE = 'SET_UPLOAD_MAINTENANCE_MESSAGE'

// Many files type Upload Module
export const FILE_SET_UPLOAD_MODAL_ERROR = 'FILE_SET_UPLOAD_MODAL_ERROR'
export const FILE_SET_UPLOAD_STATUS = 'FILE_SET_UPLOAD_STATUS'
export const FILE_SET_UPLOAD_STATUS_MESSAGE = 'FILE_SET_UPLOAD_STATUS_MESSAGE'
export const FILE_SET_UPLOAD_SHOW_OFF = 'FILE_SET_UPLOAD_SHOW_OFF'
export const FILE_SET_DUPLICATED_ORDERS = 'FILE_SET_DUPLICATED_ORDERS'
export const FILE_CLEAR_DUPLICATED_ORDERS = 'FILE_CLEAR_DUPLICATED_ORDERS'
export const FILE_SET_UPLOAD_FILES = 'FILE_SET_UPLOAD_FILES'
export const FILE_SET_FILES_SENT_STATUS = 'FILE_SET_FILES_SENT_STATUS'
export const FILE_SET_UPLOAD_MAINTENANCE_STATUS = 'FILE_SET_UPLOAD_MAINTENANCE_STATUS'
export const FILE_SET_UPLOAD_MAINTENANCE_MESSAGE = 'FILE_SET_UPLOAD_MAINTENANCE_MESSAGE'

// Order Module
export const OS_SET_LOADING_STATUS = 'OS_SET_LOADING_STATUS'
export const OS_SET_CLONE = 'OS_SET_CLONE'
export const OS_SET = 'OS_SET'
export const OS_INCREASE_OFFSET = 'OS_INCREASE_OFFSET'
export const OS_SET_MODIFIED = 'OS_SET_MODIFIED'
export const OS_SET_ERROR = 'OS_SET_ERROR'
export const OS_SET_CORRECT = 'OS_SET_CORRECT'
export const OS_DELETE = 'OS_DELETE'
export const OS_CLEAR_ALL = 'OS_CLEAR_ALL'
export const OS_LOADING_DETAILS = 'OS_LOADING_DETAILS'
export const OS_LOADING_DETAILS_SUCCESS = 'OS_LOADING_DETAILS_SUCCESS'
export const OS_LOADING_DETAILS_ERROR = 'OS_LOADING_DETAILS_ERROR'
export const OS_CLEAR = 'OS_CLEAR'
export const OS_CLEAR_OFFSET = 'OS_CLEAR_OFFSET'
export const OS_ADD_NEW_PATIENT = 'OS_ADD_NEW_PATIENT'
export const OS_EDIT_NEW_PATIENT = 'OS_EDIT_NEW_PATIENT'
export const OS_CLEAR_NEW_ORDER_DATA = 'OS_CLEAR_NEW_ORDER_DATA'
export const OS_DELETE_EXAM_ORDER = 'OS_DELETE_EXAM_ORDER'
export const OS_SET_LIST = 'OS_SET_LIST'
export const OS_SET_VERSION = 'OS_SET_VERSION'
export const OS_SORT_LIST = 'OS_SORT_LIST'
export const OS_TOTAL_COUNT = 'OS_TOTAL_COUNT'
export const OS_BREAK_STATUS = 'OS_BREAK_STATUS'
export const OS_MAINTENANCESEARCH_SHOW_OFF = 'OS_MAINTENANCESEARCH_SHOW_OFF'
export const OS_EDITING_STATUS = 'OS_EDITING_STATUS'
export const OS_FILTER_SHOW_OFF = 'OS_FILTER_SHOW_OFF'
export const OS_SET_LAST_TRANSFERED_LIST = 'OS_SET_LAST_TRANSFERED_LIST'
export const OS_SET_TRANSFER_REPORT = 'OS_SET_TRANSFER_REPORT'
export const OS_SET_TRANSFER_REPORT_LOADING = 'OS_SET_TRANSFER_REPORT_LOADING'
export const OS_CLEAR_LAST_TRANSFERED_LIST = 'OS_CLEAR_LAST_TRANSFERED_LIST'
export const OS_SET_TOTAL_EXAMS_DOC_PENDING = 'OS_SET_TOTAL_EXAMS_DOC_PENDING'
export const OS_SET_PATIENT_ROUTINE = 'OS_SET_PATIENT_ROUTINE'
export const OS_CONSENT_FORM = 'OS_CONSENT_FORM'
export const OS_EXAM_NUMBER = 'OS_EXAM_NUMBER'

// Exams Module
export const EXAM_SET_PROFILE = 'EXAM_SET_PROFILE'
export const EXAM_STATUS = 'EXAM_STATUS'
export const EXAM_DELETE_NEW = 'EXAM_DELETE_NEW'
export const EXAM_CLEAR_NEW_DATA = 'EXAM_CLEAR_NEW_DATA'
export const EXAM_UPDATE_NEW = 'EXAM_UPDATE_NEW'
export const EXAM_SET_EDITING = 'EXAM_SET_EDITING'
export const EXAM_SET_FINISH_EDITING = 'EXAM_SET_FINISH_EDITING'
export const EXAM_ADD_NEW = 'EXAM_ADD_NEW'
export const EXAM_REMOVE_LOADING = 'EXAM_REMOVE_LOADING'
export const EXAM_ADD_MOST_SENT = 'EXAM_ADD_MOST_SENT'
export const EXAM_PROFILE_LIST = 'EXAM_PROFILE_LIST'
export const EXAM_DELETE_EXAM_BY_ID = 'EXAM_DELETE_EXAM_BY_ID'
export const EXAM_REMOVE_PROFILE_BY_ID = 'EXAM_REMOVE_PROFILE_BY_ID'

// Sample Module
export const SAMPLE_SET_CURRENT_TAB = 'SAMPLE_SET_CURRENT_TAB'
export const SAMPLE_SET_LOADING_STATUS = 'SAMPLE_SET_LOADING_STATUS'
export const SAMPLE_SET = 'SAMPLE_SET'
export const SAMPLE_INCREASE_OFFSET = 'SAMPLE_INCREASE_OFFSET'
export const SAMPLE_SET_PRINTED_NUMBER = 'SAMPLE_SET_PRINTED_NUMBER'
export const SAMPLE_SET_PRINTED = 'SAMPLE_SET_PRINTED'
export const SAMPLE_SET_NOT_PRINTED = 'SAMPLE_SET_NOT_PRINTED'
export const SAMPLE_CLEAR_ALL = 'SAMPLE_CLEAR_ALL'
export const SAMPLE_SHOW_DETAILS = 'SAMPLE_SHOW_DETAILS'
export const SAMPLE_SET_PRINTED_LIST = 'SAMPLE_SET_PRINTED_LIST'
export const SAMPLE_SET_PRINTING_STATUS = 'SAMPLE_SET_PRINTING_STATUS'
export const SAMPLE_SORT_LIST = 'SAMPLE_SORT_LIST'
export const SAMPLE_TOTAL_COUNT = 'SAMPLE_TOTAL_COUNT'
export const SAMPLE_BREAK_STATUS = 'SAMPLE_BREAK_STATUS'
export const SAMPLE_FILTER_SHOW_OFF = 'SAMPLE_FILTER_SHOW_OFF'
export const SAMPLE_SET_TOTAL_EXAMS_DOC_PENDING = 'SAMPLE_SET_TOTAL_EXAMS_DOC_PENDING'
export const SAMPLE_SET_INTEGRATED = 'SAMPLE_SET_INTEGRATED'

// Result Module
export const RESULT_SET_QUERY = 'RESULT_SET_QUERY'
export const RESULT_SET_LOADING_STATUS = 'RESULT_SET_LOADING_STATUS'
export const RESULT_SET = 'RESULT_SET'
export const RESULT_SET_LIST = 'RESULT_SET_LIST'
export const RESULT_INCREASE_OFFSET = 'RESULT_INCREASE_OFFSET'
export const RESULT_CLEAR_ALL = 'RESULT_CLEAR_ALL'
export const RESULT_SENDING_XML = 'RESULT_SENDING_XML'
export const RESULT_SET_OVERDUE = 'RESULT_SET_OVERDUE'
export const RESULT_SORT_LIST = 'RESULT_SORT_LIST'
export const RESULT_TOTAL_COUNT = 'RESULT_TOTAL_COUNT'
export const RESULT_BREAK_STATUS = 'RESULT_BREAK_STATUS'
export const RESULT_BEFORE_LIST_SENDING_XML = 'RESULT_BEFORE_LIST_SENDING_XML'
export const RESULT_FILTERS = 'RESULT_FILTERS'
export const RESULT_STATISTICS = 'RESULT_STATISTICS'
export const RESULT_STATISTICS_LOADING_STATUS = 'RESULT_STATISTICS_LOADING_STATUS'
export const RESULT_EXPAND_DETAILS = 'RESULT_EXPAND_DETAILS'
export const RESULT_SET_SELECTED = 'RESULT_SET_SELECTED'
export const RESULT_SHOW_OFF_ALL_DETAILS = 'RESULT_SHOW_OFF_ALL_DETAILS'

export const RESULT_FORMAT_DATE = 'RESULT_FORMAT_DATE'

// Batches Module
export const BATCH_SET = 'BATCH_SET'
export const BATCH_SET_LOADING_STATUS = 'BATCH_SET_LOADING_STATUS'
export const BATCH_SET_CURRENT_TAB = 'BATCH_SET_CURRENT_TAB'
export const BATCH_SET_ALL_BATCHES = 'BATCH_SET_ALL_BATCHES'
export const BATCH_CLEAR_ALL = 'BATCH_CLEAR_ALL'
export const BATCH_SAMPLES_SET = 'BATCH_SAMPLES_SET'
export const BATCH_SAMPLES_CLEAR_ALL = 'BATCH_SAMPLES_CLEAR_ALL'
export const BATCH_CLEAR_OFFSET = 'BATCH_CLEAR_OFFSET'
export const BATCH_INCREASE_OFFSET = 'BATCH_INCREASE_OFFSET'
export const BATCH_SET_PRINTING_STATUS = 'BATCH_SET_PRINTING_STATUS'
export const BATCH_SET_LIST = 'BATCH_SET_LIST'
export const BATCH_BREAK_STATUS = 'BATCH_BREAK_STATUS'
export const BATCH_FILTER_SHOW_OFF = 'BATCH_FILTER_SHOW_OFF'
export const BATCH_SAMPLES_SET_PRINTING_STATUS = '  BATCH_SAMPLES_SET_PRINTING_STATUS'
export const BATCH_SET_SAMPLES = 'BATCH_SET_SAMPLES'
export const BATCH_SET_PRINTED = 'BATCH_SET_PRINTED'
export const BATCH_SET_UNPRINTED = 'BATCH_SET_UNPRINTED'
export const BATCH_SAMPLE_SHOW_DETAILS = 'BATCH_SAMPLE_SHOW_DETAILS'
export const BATCH_SAMPLE_SORT_LIST = 'BATCH_SAMPLE_SORT_LIST'
export const BATCH_SET_SORT_PRINT_SHOW_OFF = 'BATCH_SET_SORT_PRINT_SHOW_OFF'
export const BATCH_SET_SORT_PRINT_SELECT = 'BATCH_SET_SORT_PRINT_SELECT'
export const BATCH_CLOSE_ALL_SORT_PRINT_SHOW_OFF = 'BATCH_CLOSE_ALL_SORT_PRINT_SHOW_OFF'
export const BATCH_SET_SORT_TO_SAMPLES = 'BATCH_SET_SORT_TO_SAMPLES'
export const BATCH_SET_CARD_STATUS = 'BATCH_SET_CARD_STATUS'
export const BATCH_UPDATE_DETAILS_OPENED = 'BATCH_UPDATE_DETAILS_OPENED'

// GlobalModal module
export const MODAL_SHOW_IRREGULAR = 'MODAL_SHOW_IRREGULAR'
export const HELPCENTRAL_SHOW_OFF = 'HELPCENTRAL_SHOW_OFF'
export const STEPPER_MODAL_SHOW_OFF = 'STEPPER_MODAL_SHOW_OFF'
export const ATTACHMENT_MODAL_SHOW_OFF = 'ATTACHMENT_MODAL_SHOW_OFF'
export const TRACEABILITY_MAP_MODAL_SHOW_OFF = 'TRACEABILITY_MAP_MODAL_SHOW_OFF'
export const PRINTER_PLUGIN_MODAL_SHOW_OFF = 'PRINTER_PLUGIN_MODAL_SHOW_OFF'

// Date module
export const DATE_SET_UPDATETIME = 'DATE_SET_UPDATETIME'
export const DATE_SET_TODAY = 'DATE_SET_TODAY'
export const DATE_SET_YESTERDAY = 'DATE_SET_YESTERDAY'
export const DATE_SET_TOMORROW = 'DATE_SET_TOMORROW'
export const DATE_SET_TENDAYSAGO = 'DATE_SET_TENDAYSAGO'
export const DATE_SET_TWENTYDAYSAGO = 'DATE_SET_TWENTYDAYSAGO'
export const DATE_CLEAN_ALL_DATES = 'DATE_CLEAN_ALL_DATES'

// Notification module
export const COMUNICATION_SIDEBAR_SHOW_OFF = 'COMUNICATION_SIDEBAR_SHOW_OFF'
export const ALERT_SET = 'ALERT_SET'
export const ALERT_DELETE = 'ALERT_DELETE'
export const ALERT_SET_LOADING_STATUS = 'ALERT_SET_LOADING_STATUS'
export const ALERT_CLEAR = 'ALERT_CLEAR'
export const ALERT_SET_COUNT = 'ALERT_SET_COUNT'
export const ALERT_SET_FOR_LABORATORY = 'ALERT_SET_FOR_LABORATORY'
export const ALERT_SET_AS_READ = 'ALERT_SET_AS_READ'
export const ALERT_CLEAR_FOR_LABORATORY = 'ALERT_CLEAR_FOR_LABORATORY'
export const TAB_SHOW_OFF = 'TAB_SHOW_OFF'

// Message module
export const MESSAGE_DELETE = 'MESSAGE_DELETE'
export const MESSAGE_SET_FOR_LABORATORY = 'MESSAGE_SET_FOR_LABORATORY'
export const MESSAGE_CLEAR = 'MESSAGE_CLEAR'
export const MESSAGE_SET_AS_READ = 'MESSAGE_SET_AS_READ'
export const MESSAGE_SET_COUNT = 'MESSAGE_SET_COUNT'

// Voucher module
export const VOUCHER_SET_AVAILABLE_EXAMS = 'VOUCHER_SET_AVAILABLE_EXAMS'
export const VOUCHER_SET_LOADING_STATUS_EXAMS = 'VOUCHER_SET_LOADING_STATUS_EXAMS'
export const VOUCHER_SET_SELECTED_EXAMS = 'VOUCHER_SET_SELECTED_EXAMS'
export const VOUCHER_CLEAR_ALL_DATA = 'VOUCHER_CLEAR_ALL_DATA'
export const VOUCHER_INACTIVE = 'VOUCHER_INACTIVE'

// Preferences
export const PREFERENCE_SHOW_OFF = 'PREFERENCE_SHOW_OFF'
export const PREFERENCE_SET_LOADING_STATUS = 'PREFERENCE_SET_LOADING_STATUS'
export const PREFERENCE_EDIT_MODE = 'PREFERENCE_EDIT_MODE'

// Print Tag
export const PRINT_TAG_LIST_TYPE = 'PRINT_TAG_LIST_TYPE'

// Tutorial
export const TUTORIAL_MARK_AS_READ = 'TUTORIAL_MARK_AS_READ'
export const TUTORIAL_RESET = 'TUTORIAL_RESET'

// Traceability Statistics
export const TRACEABILITY_SET_LOADING_STATUS_TOTAL_DESTINATION =
  'TRACEABILITY_SET_LOADING_STATUS_TOTAL_DESTINATION'
export const TRACEABILITY_SET_DESTINATIONS = 'TRACEABILITY_SET_DESTINATIONS'
export const TRACEABILITY_SET_LOADING_STATUS_TOTAL =
  'TRACEABILITY_SET_LOADING_STATUS_TOTAL'
export const TRACEABILITY_SUM_ALL_SAMPLES_DESTINATIONS =
  'TRACEABILITY_SUM_ALL_SAMPLES_DESTINATIONS'

// Traceability Search
export const TRACEABILITY_SET_LOADING_EXAMS = 'TRACEABILITY_SET_LOADING_EXAMS'
export const TRACEABILITY_SET_ORDERS = 'TRACEABILITY_SET_ORDERS'
export const TRACEABILITY_SET_ORDERS_BY_ID = 'TRACEABILITY_SET_ORDERS_BY_ID'
export const TRACEABILITY_SET_ORDERS_LOADING_STATUS =
  'TRACEABILITY_SET_ORDERS_LOADING_STATUS'
export const TRACEABILITY_SET_SEARCH_PARAMS = 'TRACEABILITY_SET_SEARCH_PARAMS'
export const TRACEABILITY_SET_EXPAND_DETAILS = 'TRACEABILITY_SET_EXPAND_DETAILS'
export const TRACEABILITY_SET_COORDINATES_LOADING_STATUS =
  'TRACEABILITY_SET_COORDINATES_LOADING_STATUS'
export const TRACEABILITY_SET_BATCH_TRANSPORT_COORDINATES =
  'TRACEABILITY_SET_BATCH_TRANSPORT_COORDINATES'
export const TRACEABILITY_SET_BATCH_PLACE_EXECUTION_COORDINATES =
  'TRACEABILITY_SET_BATCH_PLACE_EXECUTION_COORDINATES'
export const TRACEABILITY_SET_ALL_TOTAL_STATUS = 'TRACEABILITY_SET_ALL_TOTAL_STATUS'
export const TRACEABILITY_CLEAR_ALL_TOTAL_STATUS = 'TRACEABILITY_CLEAR_ALL_TOTAL_STATUS'
export const TRACEABILITY_SET_TOTAL_DELAYED_EXAMS_COUNT =
  'TRACEABILITY_SET_TOTAL_DELAYED_EXAMS_COUNT'
export const TRACEABILITY_CLEAR_ALL_COORDINATES = 'TRACEABILITY_CLEAR_ALL_COORDINATES'
export const TRACEABILITY_SET_TOTAL_EXAMS = 'TRACEABILITY_SET_TOTAL_EXAMS'
export const TRACEABILITY_SET_CURRENT_TAB = 'TRACEABILITY_SET_CURRENT_TAB'
export const TRACEABILITY_SET_GROUPED_EXAMS_COUNT = 'TRACEABILITY_SET_GROUPED_EXAMS_COUNT'
export const TRACEABILITY_SET_COUNTERS_LOADING_STATUS =
  'TRACEABILITY_SET_COUNTERS_LOADING_STATUS'
export const TRACEABILITY_SET_PAGINATION = 'TRACEABILITY_SET_PAGINATION'
export const TRACEABILITY_RESET_PAGINATION = 'TRACEABILITY_RESET_PAGINATION'
export const TRACEABILITY_APPEND_ORDERS = 'TRACEABILITY_APPEND_ORDERS'
export const TRACEABILITY_CLEAR_ORDERS = 'TRACEABILITY_CLEAR_ORDERS'

// Service Token
export const CALL_TOKEN_LAUDASA = 'CALL_TOKEN_LAUDASA'
export const CALL_TOKEN_CHROMATOX = 'CALL_TOKEN_CHROMATOX'
export const CALL_CREDENTIALS_SHOPPING_CENTRAL = 'CALL_CREDENTIALS_SHOPPING_CENTRAL'

// Recollect
export const RECOLLECT_SET_LIST = 'RECOLLECT_SET_LIST'
export const RECOLLECT_SET_TOTAL = 'RECOLLECT_SET_TOTAL'
export const RECOLLECT_PAGINATION_SET_TOTAL = 'RECOLLECT_PAGINATION_SET_TOTAL'
export const RECOLLECT_SET_LOADING_STATUS_LIST = 'RECOLLECT_SET_LOADING_STATUS_LIST'
export const RECOLLECT_SET_LOADING_STATUS_TOTAL = 'RECOLLECT_SET_LOADING_STATUS_TOTAL'
export const RECOLLECT_CLEAR_ALL = 'RECOLLECT_CLEAR_ALL'
export const RECOLLECT_SET_SEARCH_PARAMS = 'RECOLLECT_SET_SEARCH_PARAMS'
export const RECOLLECT_INCREASE_OFFSET = 'RECOLLECT_INCREASE_OFFSET'
export const RECOLLECT_INCREASE_PAGE = 'RECOLLECT_INCREASE_PAGE'
export const RECOLLECT_SET_EXPAND_DETAILS = 'RECOLLECT_SET_EXPAND_DETAILS'
export const RECOLLECT_SET_TOTAL_REALIZADO = 'RECOLLECT_SET_TOTAL_REALIZADO'
export const RECOLLECT_SET_TOTAL_PENDENTE = 'RECOLLECT_SET_TOTAL_PENDENTE'
export const RECOLLECT_SET_TOTAL_DISPENSADO = 'RECOLLECT_SET_TOTAL_DISPENSADO'
export const RECOLLECT_SET_CURRENT_TAB = 'RECOLLECT_SET_CURRENT_TAB'
export const RECOLLECT_SET_LOADING_STATUS_SUBMIT = 'RECOLLECT_SET_LOADING_STATUS_SUBMIT'

// Pendencies
export const PENDENCIES_SET_TEXT = 'PENDENCIES_SET_TEXT'
export const PENDENCIES_INCREASE_UPLOAD_REQUESTS = 'PENDENCIES_INCREASE_UPLOAD_REQUESTS'
export const PENDENCIES_RESET_UPLOAD_REQUESTS = 'PENDENCIES_RESET_UPLOAD_REQUESTS'
export const PENDENCIES_SET_FILES_STATUS = 'PENDENCIES_SET_FILES_STATUS'
export const PENDENCIES_SET_FILE = 'PENDENCIES_SET_FILE'
export const PENDENCIES_SET_FILES = 'PENDENCIES_SET_FILES'
export const PENDENCIES_SET = 'PENDENCIES_SET'
export const PENDENCIES_SET_LOADING_STATUS = 'PENDENCIES_SET_LOADING_STATUS'
export const PENDENCIES_INCREASE_OFFSET = 'PENDENCIES_INCREASE_OFFSET'
export const PENDENCIES_CLEAR_ALL = 'PENDENCIES_CLEAR_ALL'
export const PENDENCIES_SET_FILTER = 'PENDENCIES_SET_FILTER'
export const PENDENCIES_TOTAL_QUANTITY = 'PENDENCIES_TOTAL_QUANTITY'
export const PENDENCIES_TOTAL_SET_LOADING_STATUS = 'PENDENCIES_TOTAL_SET_LOADING_STATUS'
export const PENDENCIES_SET_UPLOAD_STATUS = 'PENDENCIES_SET_UPLOAD_STATUS'
export const PENDENCIES_SET_REPLY_STATUS = 'PENDENCIES_SET_REPLY_STATUS'
export const PENDENCIES_DOWNLOADING_STATUS = 'PENDENCIES_DOWNLOADING_STATUS'
export const PENDENCIES_SET_TOTAL_PENDENTE = 'PENDENCIES_SET_TOTAL_PENDENTE'
export const PENDENCIES_SET_TOTAL_REALIZADO = 'PENDENCIES_SET_TOTAL_REALIZADO'
export const PENDENCIES_SET_CURRENT_TAB = 'PENDENCIES_SET_CURRENT_TAB'
export const PENDENCIES_SET_SUBMIT_LOADING_STATUS = 'PENDENCIES_SET_SUBMIT_LOADING_STATUS'

// Reschedule
export const RESCHEDULE_SET_LIST = 'RESCHEDULE_SET_LIST'
export const RESCHEDULE_SET_LOADING_STATUS_LIST = 'RESCHEDULE_SET_LOADING_STATUS_LIST'
export const RESCHEDULE_SET_TOTAL = 'RESCHEDULE_SET_TOTAL'
export const RESCHEDULE_SET_LOADING_STATUS_TOTAL = 'RESCHEDULE_SET_LOADING_STATUS_TOTAL'
export const RESCHEDULE_CLEAR_ALL = 'RESCHEDULE_CLEAR_ALL'
export const RESCHEDULE_SET_SEARCH_PARAMS = 'RESCHEDULE_SET_SEARCH_PARAMS'

// Panic Alert
export const PANIC_ALERT_SET_LIST = 'PANIC_ALERT_SET_LIST'
export const PANIC_ALERT_SET_LOADING_STATUS_LIST = 'PANIC_ALERT_SET_LOADING_STATUS_LIST'
export const PANIC_ALERT_SET_TOTAL = 'PANIC_ALERT_SET_TOTAL'
export const PANIC_ALERT_SET_LOADING_STATUS_TOTAL = 'PANIC_ALERT_SET_LOADING_STATUS_TOTAL'
export const PANIC_ALERT_CLEAR_ALL = 'PANIC_ALERT_CLEAR_ALL'
export const PANIC_ALERT_SET_SEARCH_PARAMS = 'PANIC_ALERT_SET_SEARCH_PARAMS'
export const PANIC_ALERT_UPDATE_READ_STATUS = 'PANIC_ALERT_UPDATE_READ_STATUS'
export const PANIC_ALERT_SET_LOADING_STATUS_SUBMIT =
  'PANIC_ALERT_SET_LOADING_STATUS_SUBMIT'

// Feature Toggle
export const TOGGLE_SET_VALUE = 'TOGGLE_SET_VALUE'

// collectionPoint
export const COLLECTION_POINT_BATCHES = 'COLLECTION_POINT_BATCHES'
export const COLLECTION_POINT_SERVICE_STATUS = 'COLLECTION_POINT_SERVICE_STATUS'
export const COLLECTION_POINT_UPDATE_LIST = 'COLLECTION_POINT_UPDATE_LIST'
export const COLLECTION_POINT_LOADING_STATUS = 'COLLECTION_POINT_LOADING_STATUS'

// ExamProfile
export const EXAM_PROFILE_STATUS = 'EXAM_PROFILE_STATUS'
export const EXAM_PROFILE_UPDATE_LIST = 'EXAM_PROFILE_UPDATE_LIST'

// patient
export const PATIENT_UPDATE_LIST = 'PATIENT_UPDATE_LIST'
export const PATIENT_STATUS = 'PATIENT_STATUS'

// doctor
export const DOCTOR_UPDATE_LIST = 'DOCTOR_UPDATE_LIST'
export const DOCTOR_STATUS = 'DOCTOR_STATUS'

// supply
export const SUPPLY_UPDATE_LIST = 'SUPPLY_UPDATE_LIST'
export const SUPPLY_LOADING = 'SUPPLY_LOADING'

// Help Center Tutorials
export const TUTORIALS_LIST_UPDATE = 'TUTORIALS_LIST_UPDATE'
